/* eslint-disable import/prefer-default-export */
import { Axis } from '../types'

export const getGaugeAxisRange = (axis: Axis | undefined, isNetSentiment: boolean) => {
  const axisMin = axis?.min
  const axisMax = axis?.max
  return isNetSentiment
    ? {
        yAxisMin: axisMin ? axisMin * 100 : 0,
        yAxisMax: axisMax ? axisMax * 100 : 0
      }
    : {
        yAxisMin: axisMin || 0,
        yAxisMax: axisMax || 0
      }
}
